<template>
  <div>
    <template v-if="getWebsiteProductLoading">
      <Loader></Loader>
    </template>
    <template v-else>
      <TopBar :page="topBarData" @menuItemClick="topMenuClicked"/>
      
      <v-container fluid>

        <RetentionBanner :productId="getCurrentProduct.id" />

        <Details />

        <template v-if="tarrifVersion===2">
          <v-row>

            <v-col cols="12" md="6">
              <WebsiteTariffDetails />
            </v-col>

            <v-col cols="12" md="6">
              <Notes :id="$route.params.id" notesType="product">
                <template #additional-buttons>
                  <v-btn color="secondary" x-small :to="`/products/${$route.params.id}/histories`" target="_blank"><v-icon small>{{mdiOpenInNew}}</v-icon></v-btn>
                </template>
              </Notes>
            </v-col>

          </v-row>

          <v-row>

            <v-col cols="12" md="6">
              <DomainAndEmails />
            </v-col>

          </v-row>
        </template>
        <template v-else>
          <v-row>

            <v-col cols="12" md="6">
              <WebsiteTariffV1Details />
            </v-col>

            <v-col cols="12" md="6">
              <Notes :id="$route.params.id" notesType="product">
                <template #additional-buttons>
                  <v-btn color="secondary" x-small :to="`/products/${$route.params.id}/histories`" target="_blank"><v-icon small>{{mdiOpenInNew}}</v-icon></v-btn>
                </template>
              </Notes>
            </v-col>

          </v-row>
        </template>
        
      </v-container>

      <ConvertConfirmOpen :dialogOpen="convertConfirmOpen" @close-dialog="convertConfirmOpen=false;" />
      <StatusHistoryDialog :product_id="getCurrentProduct.id" :dialogOpen="statusHistoryOpen" @close-dialog="statusHistoryOpen=false;" />
      <AdhocCreateInvoiceDialog @close-dialog="setAdhocCreateInvoiceOpen(false)"/>
      <AdhocHistoryDialog :dialogOpen="adhocHistoryOpen" @close-dialog="adhocHistoryOpen=false"/>
      <ProductAuditDialog v-model="productAuditDialogOpen" />
      <CreateNewTicket :dialogOpen="newTicketOpen" @close-dialog="newTicketOpen=false;"/>
      <SendTrustpilotReviewDialog :open="sendTrustpilotReviewDialogOpen" @close="sendTrustpilotReviewDialogOpen=false"/>
    </template>
  </div>
</template>

<script>
  import TopBar from "../../../Layout/TopBar";

  import Loader from "../../../Misc/Loader";

  import Details from "../AllProducts/Details";
  import WebsiteTariffDetails from "./WebsiteTariffDetails";
  import WebsiteTariffV1Details from "./WebsiteTariffV1Details";
  import DomainAndEmails from "./DomainAndEmails";
  import ConvertConfirmOpen from "./ConvertConfirmOpen";
  import Notes from "@/components/Globals/Notes/Notes";
  import { mdiOpenInNew } from '@mdi/js';

  import StatusHistoryDialog from "../AllProducts/StatusHistoryDialog";
  import AdhocCreateInvoiceDialog from "../AllProducts/Adhoc/AdhocCreateInvoiceDialog";
  import AdhocHistoryDialog from "../AllProducts/Adhoc/AdhocHistoryDialog";
  import ProductAuditDialog from '@/components/Products/ProductTypes/AllProducts/ProductAuditDialog';
  import CreateNewTicket from "@/components/Tickets/Dialogs/CreateNewTicket";
  import RetentionBanner from '@/components/Products/ProductTypes/AllProducts/RetentionBanner';
  import SendTrustpilotReviewDialog from '@/components/Products/ProductTypes/AllProducts/SendTrustpilotReviewDialog';
  
  import { mapState, mapActions,mapMutations,mapGetters } from "vuex";
  import moment from 'moment';

  const QUEUE_URL = process.env.VUE_APP_QUEUE_URL || `https://queues-bonline-testing.appspot.com/`;
  const OLD_CRM_LINK = process.env.VUE_APP_API_HOST || `https://ctst-testing.appspot.com/`;

  export default {
    components: {TopBar,Details,Loader,WebsiteTariffDetails,WebsiteTariffV1Details,DomainAndEmails,Notes,StatusHistoryDialog,AdhocCreateInvoiceDialog,AdhocHistoryDialog,ConvertConfirmOpen, ProductAuditDialog,RetentionBanner,CreateNewTicket,SendTrustpilotReviewDialog},
    
    data() {
      return {
        product: {},
        adhocHistoryOpen: false,
        statusHistoryOpen: false,
        convertConfirmOpen: false,
        mdiOpenInNew,
        productAuditDialogOpen: false,
        newTicketOpen:false,
        sendTrustpilotReviewDialogOpen: false
      }
    },

    async mounted (){
      if(this.tarrifVersion===2){
        await this.fetchWebsiteDetails();
        await this.fetchAllTariffs();
        await this.fetchAllAddons();
      }
      this.addRecentlyViewed({
        id: this.getCurrentProduct.id,
        name: this.topBarData.name,
        type: 'web',
        status: this.getCurrentProduct.status,
        datetime: new Date()
      });
    },

    computed: {
      ...mapState('accounts', ['currentAccount']),
      ...mapGetters('productWebsite',['getCurrentProduct','getLinkedAccount','getTopBar','getWebsiteProductLoading']),
      ...mapGetters('comms', ['getContacts', 'getContactsError']),

      topBarData (){
        return {
          name:this.getTopBar.title,
          type:'productWebsite',
          menu:true,
          showSearch:true,
          breadcrumbs:this.getTopBar.breadcrumbs,
        };
      },

      tarrifVersion(){
        return parseInt(this.getCurrentProduct.tariff_version.replace('TARIFF_V',''));
      }
    },

    methods: {
      ...mapActions('globals',['addRecentlyViewed']),
      ...mapActions('productWebsite',['fetchWebsiteDetails','fetchAllTariffs','fetchAllAddons','convertProductToWeb2']),
      ...mapActions('comms', ['fetchContacts']),
      ...mapActions('alerts', ['setAlert']),
      ...mapMutations('adhoc',['setAdhocCreateInvoiceOpen']),
      
      async topMenuClicked(menuItem){
        switch(menuItem){
          case 'newTicket':
            this.newTicketOpen = true;
            break;
          case 'ticketsPage':
            this.$router.push(`/tickets?product_id=${this.$route.params.id}`);
            break;
          case 'adhocHistory':
            this.adhocHistoryOpen = true;
            break;
          case 'adhocCreateInvoice':
            this.setAdhocCreateInvoiceOpen(true);
            break;
          case 'hardwareOrderingQueue':
            window.open(`${QUEUE_URL}hardware-ordering/actions/?account_id=${this.getLinkedAccount.id}`);
            break;
          case 'statusHistory':
            this.statusHistoryOpen = true;
            break;
          case 'viewOnOldCrm':
            window.open(`${OLD_CRM_LINK}sites/search?query=${this.getCurrentProduct.id}`);
            break;
          case 'goToLead':
            this.$router.push(`/leads/${this.$route.params.id}/`);
            break;
          case 'convertToWeb2':
            this.convertConfirmOpen = true;
            break;
          case 'audit':
            this.productAuditDialogOpen = true;
            break;
          case 'comms':
            this.goToComms();
            break;
          case 'sendTrustpilotEmail':
            this.openSendTrustpilotReviewDialog();
            break;
        }
      },

      async goToComms() {
        const data = {type: 'product', id: this.getCurrentProduct.id};
        await this.fetchContacts(data);
        
        if (!this.getContactsError) {
          const emails = [...new Set(this.getContacts.map( contact => {
            if (contact.email_address ) { return contact.email_address }
          }))];
          const phone_numbers = [...new Set(this.getContacts.map( contact => {
            if (contact.phone_number) { return contact.phone_number }
          }))];
          const mobile_numbers = [...new Set(this.getContacts.map( contact => {
            if (contact.mobile_number) { return contact.mobile_number }
          }))];
          const numbers = [...new Set(phone_numbers.concat(mobile_numbers))];

          localStorage.setItem('comms_emails', JSON.stringify(emails));
          localStorage.setItem('comms_numbers', JSON.stringify(numbers));

          window.open('/comms/');
        }
      },

      openSendTrustpilotReviewDialog() {
        if (!this.getCurrentProduct.account_id) {
          this.setAlert({type: 'error', message: 'Unable to send Trustpilot review: Please link a billing account to the product first'});
          return;
        }

        let trustpilotReviewSent = false;
        if (this.currentAccount.last_trustpilot_review) {
          const date = moment(new Date());
          trustpilotReviewSent =  date.diff(moment(this.currentAccount.last_trustpilot_review), 'days') <= 7;
        }

        if (trustpilotReviewSent) {
          this.setAlert({type: 'error', message: 'Sorry, a review cannot be submitted as one was already submitted on Trustpilot within the last 7 days.'});
        } else {
          this.sendTrustpilotReviewDialogOpen = true;
        }
      }
    },
  }
</script>
<style lang="scss" scoped></style>
